<!--  -->
<template>
  <div>
    <div class="choose_palte">
      <div class="chasew">标题：</div>
      <div>
        <el-input v-model="title" placeholder="请输入标题" style="width:200px" />
      </div>
    </div>
    <!-- <div class="choose_palte">
      <div class="chasew">选择书籍：</div>
      <div>
        <el-tag v-if="bookid" class="sdarw">{{ bookname }}</el-tag>
        <el-button type="primary" size="mini" @click="choosebookid">选择书籍</el-button>
      </div>
    </div> -->
    <div class="choose_palte">
      <div class="chasew">是否公开：</div>
      <div>
        <el-select
          v-model="openform"
          class="launch"
          filterable
          placeholder="是否公开"
          @change="changeopen"
        >
          <el-option
            v-for="item in platforms"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>
    </div>
    <div v-if="openform === 1" class="choose_palte">
      <div class="chasew">赠送标准：</div>
      <div>
        <el-input v-model="give" placeholder="请输入赠送标准" style="width:200px" />
      </div>
    </div>
    <div class="choose_palte">
      <div class="chasew">
        底部图片：
      </div>
      <div :class="[updatapath ? '' : 'wrwaw']">
        <div :class="[updatapath ? '' : 'updatabocwr']" @click="$refs.file.click()">
          <input ref="file" style="display:none;" type="file" multiple accept="image/gif,image/jpg,image/jpeg,image/png" @change.stop="uploadPicturesall">
          <img v-if="updatapath" :src="updatapath" class="updata_casr">
          <i v-else class="el-icon-upload" />
        </div>
      </div>
    </div>
    <div class="choose_palte">
      <div class="chasew">
        封面图片：
      </div>
      <div :class="[updatapathtop ? '' : 'wrwaw']">
        <div :class="[updatapathtop ? '' : 'updatabocwr']" @click="$refs.files.click()">
          <input ref="files" style="display:none;" type="file" multiple accept="image/gif,image/jpg,image/jpeg,image/png" @change.stop="uploadPicturesr">
          <img v-if="updatapathtop" :src="updatapathtop" class="updata_casr">
          <i v-else class="el-icon-upload" />
        </div>
      </div>
    </div>
    <el-button type="primary" class="savebox" :disabled="disabledsave" @click="saveclickr">保存</el-button>

    <el-dialog
      title="选择书籍"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="dialogVisibler"
      width="40%"
    >
      <chooseaccount ref="chooseviewr" @callback="callback" />
    </el-dialog>
  </div>
</template>

<script>
import { qiniuToken } from '@/api/qiniuToken.js'
import * as qiniu from 'qiniu-js'
import { newMaterial, activitycover, atlasupdata } from '@/api/sourceMaterial.js'
import chooseaccount from './chooseaccount.vue'
export default {
  components: {
    chooseaccount
  },
  data() {
    return {
      onetype: null,
      title: '', // 标题
      bookid: null, // 书籍id
      bookname: '', // 书籍名称
      openform: 1, // 是否公开
      give: '', // 赠送标准
      updatapath: null, // 底部图片上传地址
      updataid: null, // 底部图片上传id

      updatapathtop: 'https://ziyuan.jingxuansz.com/user/xt291c--A飞书20220917-170858.png', // 封面图片上传地址
      updataidtop: 292, // 封面图片上传id

      dialogVisibler: false, // 书籍弹窗
      disabledsave: false, // 保存

      platforms: [
        {
          name: '公开',
          id: 2
        },
        {
          name: '不公开',
          id: 1
        }
      ],
      query: {},
      bids: null
    }
  },
  created() {
    this.getQiniuToken()
  },
  mounted() {

  },
  methods: {
    // 获取七牛云token
    async getQiniuToken() {
      const data = await qiniuToken()
      this.token = data.data.upToken
    },
    send(type, query, item) {
      console.log('type query', type, query)
      this.onetype = type
      this.query = query
      if (type === 1) {
        console.log('新增')
      } else {
        this.title = item.title
        this.bookid = item.bookId
        this.bookname = item.bookName
        this.openform = item.isOpen
        // eslint-disable-next-line eqeqeq
        if (item.isOpen == 1) {
          this.give = item.chapterGive
        }
        this.updatapath = item.bottomPicturePath
        this.updataid = item.bottomPicture
        this.updatapathtop = item.coverPicturePath
        this.updataidtop = item.coverPicture
        this.bids = item.id
        console.log('编辑', item)
      }
    },
    // 上传底部图片
    async uploadPicturesall(e) {
      console.log('取消', 66666)

      const fileIfon = e.target.files[0]
      const img = new Image()
      // const temporary = window.URL.createObjectURL(fileIfon)
      // img.src = temporary
      // this.temporary = temporary
      const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '--' + fileIfon.name}`, this.token, {
        fname: fileIfon.name // 文件名
      }, {
        useCdnDomain: true // cdn域名加速
      })
      observable.subscribe({
        next() { },
        error(err) {
          console.log(err)
        },
        complete: (data) => {
          setTimeout(async() => {
            this.loading = true
            const datas = await newMaterial({
              type: 1,
              height: img.height,
              width: img.width,
              size: fileIfon.size,
              key: data.key
            })
            console.log('datas底部', datas.data.path)
            this.updatapath = datas.data.path
            this.updataid = datas.data.sourceMaterialId
            this.loading = false
            // await this.getlist()
            this.temporary = null
          }, 100)
        }

      })
    },
    // 上传封面
    async uploadPicturesr(e) {
      console.log('取消', e)

      const fileIfon = e.target.files[0]
      const img = new Image()
      // const temporary = window.URL.createObjectURL(fileIfon)
      // img.src = temporary
      // this.temporary = temporary
      const observable = qiniu.upload(fileIfon, `user/${Math.random().toString(36).slice(-6) + '--' + fileIfon.name}`, this.token, {
        fname: fileIfon.name // 文件名
      }, {
        useCdnDomain: true // cdn域名加速
      })
      observable.subscribe({
        next() { },
        error(err) {
          console.log(err)
        },
        complete: (data) => {
          setTimeout(async() => {
            this.loading = true
            const datas = await newMaterial({
              type: 1,
              height: img.height,
              width: img.width,
              size: fileIfon.size,
              key: data.key
            })
            console.log('datas321312321', datas.data.path)
            this.updatapathtop = datas.data.path
            this.updataidtop = datas.data.sourceMaterialId
            this.loading = false
            // await this.getlist()
            this.temporary = null
          }, 100)
        }

      })
    },
    // 是否公开事件
    changeopen(val) {
      console.log('val', val)
      if (val === 1) {
        console.log('不公开')
      } else {
        console.log('公开')
        this.give = ''
      }
    },
    // 保存
    async saveclickr() {
      if (this.title === '') {
        this.$message.error('请输入标题')
        return
      }
      // if (this.bookid === null) {
      //   this.$message.error('请选择书籍')
      //   return
      // }
      if (this.openform === 1 && this.give === '') {
        this.$message.error('请输入赠送标准')
        return
      }
      if (this.updataid === null) {
        this.$message.error('请选择底部封面')
        return
      }
      if (this.updataidtop === null) {
        this.$message.error('请选择封面')
        return
      }
      this.disabledsave = true
      if (this.onetype === 1) {
        const data = await activitycover({
          atlasId: this.query.id,
          appId: this.query.appId,
          title: this.title,
          bottomPicture: this.updataid,
          coverPicture: this.updataidtop,
          bookId: this.bookid,
          isOpen: this.openform,
          chapterGive: this.give
        })
        this.$message({
          message: '新增成功',
          type: 'success'
        })
        console.log('data', data)
      } else {
        console.log('编辑')
        const data = await atlasupdata({
          atlasId: this.query.id,
          appId: this.query.appId,
          title: this.title,
          bottomPicture: this.updataid,
          coverPicture: this.updataidtop,
          bookId: this.bookid,
          isOpen: this.openform,
          chapterGive: this.give,
          id: this.bids
        })
        this.$message({
          message: '更新成功',
          type: 'success'
        })
        console.log('编辑data', data)
      }

      this.$emit('closer')
      this.disabledsave = false
    },
    callback(item) {
      console.log('item 选择完书籍的回调', item)
      this.bookname = item.novelTitle
      this.bookid = item.bookId
      this.dialogVisibler = false
      // 选择完书籍的回调
    },
    choosebookid() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.chooseviewr.send(this.query)
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.choose_palte{
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.chasew{
  width: 80px;
  text-align: right;
}
.updatabocwr{
background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 130px;
    height: 130px;
    cursor: pointer;
    line-height: 146px;
    vertical-align: top;
    text-align: center;

}
.updatabocwr i {
      font-size: 28px;
    color: #8c939d;
}
.updatabocwr i:hover {
    border: none;
}
.wrwaw :hover{
  border: 1px dashed #409eff;
}
.updata_casr{
    width: 130px;
    height: 130px;
}
.savebox{
  margin-left: 10px;
}
.sdarw{
  margin-right: 10px;
}
</style>
